import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { profileDetails } from "../../services/ProfileService";

/* ================= THUNK ================= */

export const fetchProfileDetails = createAsyncThunk(
  "profileDetails/fetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await profileDetails(params);

      if (res?.status === 200 && res?.data) {
        return res.data;
      }

      return rejectWithValue(res?.message || "Failed to fetch profile");
    } catch (err) {
      return rejectWithValue(err?.message || "Something went wrong");
    }
  },
);

/* ================= INITIAL STATE ================= */

const initialState = {
  data: null,
  loading: false,
  error: null,
};

/* ================= SLICE ================= */

const profileDetailsSlice = createSlice({
  name: "profileDetails",
  initialState,
  reducers: {
    clearProfileDetails: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfileDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfileDetails.fulfilled, (state, action) => {
        state.loading = false;

        const d = action.payload || {};
        const org = d?.organization;

        state.data = {
          _id: d?._id || null,
          firstName: d?.firstName || "",
          lastName: d?.lastName || "",
          email: d?.email || "",
          bio: d?.bio || "",

          image: d?.image?.url || null,
          coverMedia: d?.coverMedia?.url || null,

          /* ===== ORGANIZATION ===== */
          organization: org?._id
            ? {
                id: org?._id || null,
                slug: org?.slug || null,

                name: org?.content?.en?.title || "No Organization",

                description: org?.content?.en?.content || "",

                excerpt: org?.content?.en?.excerpt || "",

                logo: org?.logo?.url?.url || null,

                coverImage: org?.coverImage?.url?.url || null,

                website: org?.socialLinks?.website || null,

                address: (() => {
                  const addr = org?.address?.[0];

                  if (!addr) return null;

                  return {
                    city: addr?.city || "",
                    state: addr?.state || "",
                    country: addr?.country || "",
                    full:
                      [addr?.city, addr?.state, addr?.country]
                        .filter(Boolean)
                        .join(", ") || null,
                  };
                })(),
              }
            : null,
        };
      })
      .addCase(fetchProfileDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching profile";
      });
  },
});

export const { clearProfileDetails } = profileDetailsSlice.actions;
export default profileDetailsSlice.reducer;
